import { Link } from 'react-router-dom';

import { ICheckesDataResponse } from 'ApiPackage/OpenDataModule/interfaces/ICheckesDataResponse';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG } from 'CorePackage/MainModule/constants/dateFormat';
import { ROUTE_OPEN_DATA } from 'CorePackage/MainModule/constants/routes';

import styles from './OpenDataShared.module.scss';
import { TermsOfUseFooter } from './TermsOfUseFooter';

interface IPassportComponentProps {
  data: ICheckesDataResponse;
}

export const PassportComponent = ({ data }: IPassportComponentProps) => {
  const { datasetPassport } = data;
  const dateFirstPublished = datasetPassport?.firstPublished
    ? formatDate({ date: datasetPassport.firstPublished, dateFormat: DATE_FORMAT_LONG })
    : '';
  const dateLastChanged = datasetPassport?.lastChanged
    ? formatDate({ date: datasetPassport?.lastChanged, dateFormat: DATE_FORMAT_LONG })
    : '';
  return (
    <div>
      {datasetPassport && (
        <div>
          <div className={styles.TablePassport}>
            <tbody>
              <tr>
                <td>Ссылка на версию, которой соответствует публикация этого паспорта набора открытых данных</td>
                <td>
                  <Link to={ROUTE_OPEN_DATA}>{datasetPassport.openDataVersionUrl}</Link>
                </td>
              </tr>
              <tr>
                <td>Идентификационный номер набора данных</td>
                <td>{datasetPassport.datasetId}</td>
              </tr>
              <tr>
                <td>Наименование набора данных</td>
                <td>{datasetPassport.datasetName}</td>
              </tr>
              <tr>
                <td>Описание набора данных</td>
                <td>{datasetPassport.datasetDescription}</td>
              </tr>
              <tr>
                <td>Владелец набора данных</td>
                <td>{datasetPassport.datasetOwner}</td>
              </tr>
              <tr>
                <td>Дата первой публикации набора данных в формате ISO 8601</td>
                <td>{dateFirstPublished}</td>
              </tr>
              <tr>
                <td>Дата последнего внесения изменений в формате ISO 8601</td>
                <td>{dateLastChanged}</td>
              </tr>
              <tr>
                <td>Ключевые слова, соответствующие содержанию набора данных</td>
                <td>{datasetPassport.keywords}</td>
              </tr>
              <tr>
                <td>Формат данных</td>
                <td>{datasetPassport.dataFormat}</td>
              </tr>
              <tr>
                <td>Имя ответственного лица </td>
                <td>{datasetPassport.personInCharge}</td>
              </tr>
              <tr>
                <td>Телефон ответственного лица</td>
                <td />
              </tr>
              <tr>
                <td>Адрес электронной почты ответственного лица </td>
                <td />
              </tr>
            </tbody>
          </div>
          <TermsOfUseFooter />
        </div>
      )}
    </div>
  );
};
